<template>
  <div v-if="dataLoading" class="loading-overlay">
    <div class="loading-overlay-content">
      <img src="/images/loading.gif" alt="読み込み中" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataLoading: false
    }
  },
  methods: {
    start() {
      this.dataLoading = true
    },
    finish() {
      this.dataLoading = false
    }
  }
}
</script>
